import { format, parseISO } from "date-fns";
import { localizedFormatDate } from "./userLocale";

export const parseListDate = (
  dateString: string,
  showTime: boolean,
  comms?: boolean
) => {
  try {
    const splitDateTime = dateString.split("T");

    if (splitDateTime.length === 2) {
      // OLD method, causes timezone issues based on user's computer's set timezone:
      // const parsedDate = localizedFormatDate(new Date(splitDateTime[0]));

      let parsedDate = "";
      try {
        parsedDate = format(parseISO(dateString), "dd-MMM-yyyy");
      } catch {
        parsedDate = splitDateTime[0];
      }

      const parsedTime = splitDateTime[1].split(".")[0]; // Remove seconds decimal places if they exist

      if (showTime) {
        return comms
          ? `${parsedDate} ${parsedTime}`
          : `${parsedDate}:${parsedTime}`;
      } else {
        return parsedDate;
      }
    } else {
      return dateString;
    }
  } catch {
    console.log("Failed to parse list date: ", dateString);
    return dateString;
  }
};
